import { createSlice } from '@reduxjs/toolkit';

/**
 * @type {CompetitionNavState}
 */
const initialState = {
    competition: {
        id: '',
        providerId: ''
    },
    season: {
        id: '',
        providerId: ''
    },
    seasons: [],
    round: '',
    rounds: [],
    filters: {
        teams: [],
        venues: [],
        cities: []
    },
    bettingOdds: {
        isActive: true
    },
    live: {
        isActive: true
    },
    location: {
        timezone: ''
    },
    ready: false
};

const competitionNavV2 = createSlice({
    name: 'competition-nav-v2',
    initialState: () => initialState,
    reducers: {
        setNavItem: (state, action) => {
            const { navItem, value } = action.payload;

            if (state[navItem] === null) {
                state[navItem] = value;
            } else if (Array.isArray(state[navItem])) {
                state[navItem] = value;
            } else if (typeof state[navItem] === 'object') {
                state[navItem] = { ...state[navItem], ...value };
            } else {
                state[navItem] = value;
            }
        },
        setFilterItem: (state, action) => {
            const { filterItem, value } = action.payload;
            state.filters[filterItem] = value;
        },
        setNavReady: (state, action) => {
            state.ready = action.payload;
        },
        setBettingOdds: (state, action) => {
            const { payload } = action;

            state.bettingOdds = {
                ...state.bettingOdds,
                ...payload
            };
        },
        setLive: (state, action) => {
            const { payload } = action;

            state.live = {
                ...state.live,
                ...payload
            };
        }
    }
});

// RTK Query update: Export the slice reducer and actions
if (PULSE.app.redux) {
    PULSE.app.redux.reducers.competitionNavV2 = {
        root: competitionNavV2.reducer
    };
    PULSE.app.redux.actions = {
        ...PULSE.app.redux.actions,
        competitionNavV2: competitionNavV2.actions
    };
} else {
    PULSE.app.redux = {
        actions: {
            competitionNavV2: competitionNavV2.actions
        },
        reducers: {
            root: {
                competitionNavV2: competitionNavV2.reducer
            }
        }
    };
}

export const {
    setNavItem,
    setFilterItem,
    setNavReady,
    setBettingOdds,
    setLive
} = competitionNavV2.actions;
